import $ from 'jquery';

export default {
	name: 'assures',
	components: {},
	props: [],
	data() {
		return {
			user_id: 0,
			fields: [
				'souscripteurs', { key: 'date_effet', label: 'Date d\'effet' }, 
				{ key: 'date_expire', label: 'Date d\'expiration' }, { key: 'etat', label: 'État' }, 
				{ key: 'action', label: 'Action.s' }
			],

			filter: "",
			tableIsBusy: true,
			perPage: 20,
			currentPage: 1,

			assure_is_empty: false,
			assure_is_loading: true,
			import_loading: false,

			assurance_id: 0,

			files: [],
			liste_medicaments: [
				{
					libelle: ''
				}
			],

			liste_prestations: [
                { 'slug': 'Consultation', 'libelle': 'Consultation', 'is_set': false },
                { 'slug': 'Analyses', 'libelle': 'Analyses', 'is_set': false },
                { 'slug': 'Examens', 'libelle': 'Examens', 'is_set': false },
                { 'slug': 'Médicaments', 'libelle': 'Médicaments', 'is_set': false },
                { 'slug': 'Consommables', 'libelle': 'Consommables', 'is_set': false },
                { 'slug': 'Chirurgie', 'libelle': 'Chirurgie', 'is_set': false },
                { 'slug': 'Bilan de santé', 'libelle': 'Bilan de santé', 'is_set': false },
                { 'slug': 'Admission', 'libelle': 'Admission', 'is_set': false },
                { 'slug': 'Acte', 'libelle': 'Acte', 'is_set': false },
                { 'slug': 'Observation', 'libelle': 'Observation', 'is_set': false },
                { 'slug': 'Chambre', 'libelle': 'Chambre', 'is_set': false },
            ],

			// Souscripteur form
			souscripteur: {
				user_id: 0,
				is_edit: 0,
				assurance_id: 0,
				societe: '',
				date_effet: '',
				date_expire: '',
				c_model: []
			},
			save_loading: false,
			btn_disable: false,

			liste_taux_prestation: [],

			c_loading: true,

			// taux assurance - plafond
			taux_fields: [
				'prestation', { key: 'action', label: 'Action.s' }
			],
			is_liste_taux: true,

			taux_couverture: [],
			is_edit: 0,

			to_be_deleted: [],
            del_loading: false,
            is_confirm: false,
			societe_is_exist: false,

			liste_champs_taux: [],
			choice_empty: false,
			is_error: false
		}
	},

	computed: {
		/**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

		rows() {
            return this.souscripteurs.length;
        },

		souscripteurs() {
            return this.$store.getters["souscripteurs"];
        },

		categorie_medicaments() {
			return this.$store.getters["categorie_medicaments"];
		},

		champ_taux_assurance() {
			return this.$store.getters["champ_taux_assurance"];
		},
	},
	mounted() {
		this.user_id = this.userCredentials.id
		this.assurance_id = this.$route.params.id

		// Liste des souscripteurs d'une assurance
		this.refreshListeSouscripteur()

		this.$store.dispatch("getCategorieMedicaments")

		// Champ taux assurance
		this.getChampTauxAssurance(this.$route.params.id)
	},
	methods: {
		getChampTauxAssurance(assurance_id) {
			this.souscripteur.c_model = []
			this.$store.dispatch("getChampsTauxAssurance", assurance_id).then(() => {
				
				this.champ_taux_assurance.forEach(el => {
					this.souscripteur.c_model.push({ valeur: '', champ_id: el.champ_id, champ_taux: el.champ_taux })
				});

				this.liste_prestations.forEach((prestation, index) => {
					this.champ_taux_assurance.forEach(taux => {
						if (taux.champ_taux == prestation.libelle) {
							this.liste_prestations[index].is_set = true
						}
					});
				});
				
				this.c_loading = false
			})
		},

		handleSouscripteur() {
			this.liste_champs_taux = this.champ_taux_assurance

			this.champ_taux_assurance.forEach((el, i) => {
				this.souscripteur.c_model[i].valeur = ''
			});
			this.souscripteur.societe = ''
			this.souscripteur.date_effet = ''
			this.souscripteur.date_expire = ''
			this.souscripteur.is_edit = 0

			this.$refs.add_souscripteur.reset()

			$('.add-souscripteur').modal('show')
		},

		handleFilesUpload() {
            let uploadedFiles = this.$refs.files.files;
            /*
              Adds the uploaded file to the files array
            */
            this.files = []
            for (var i = 0; i < uploadedFiles.length; i++) {
                this.files.push(uploadedFiles[i]);
            }
			$('.err-msg').fadeOut()
        },

		refreshListeSouscripteur() {
			this.assure_is_loading = true
			this.$store.dispatch("listeSouscripteur", this.$route.params.id).then(() => {
				if(this.souscripteurs.length > 0) {
					this.assure_is_empty = false
				} else {
					this.assure_is_empty = true
				}
				this.assure_is_loading = false
			});
		},

		importer() {
			this.import_loading = true
            let formData = new FormData();
            $('.err-msg').fadeOut()

            let err = 0

            if (this.files.length == 0) {
                err++
            }

            if (err == 0) {
                formData.append('file', this.files[0]);

				formData.append('categorie_len', this.categorie_medicaments.length);
				for (let i = 0; i < this.categorie_medicaments.length; i++) {
					formData.append('medicament_cat_'+i, this.categorie_medicaments[i].libelle);
				}
				
                this.$store.dispatch("importerSouscripteur", { 
					'assurance_id': this.$route.params.id, 'user_id': this.user_id, 'data': formData
				}).then(() => {
                    this.import_loading = false
                    // après le rendu sur la page, faire disparaitre le modal
                    this.files = []

                    this.$refs.close_modal.click()
					this.refreshListeSouscripteur()

                    this.successMsg("La liste actualisée des assurés importé avec succès.");


                }, error => {
                    if (error.response) {
                        // this.doErrorMsg("Erreur d'enregistrement")
                        this.import_loading = false
                    }

                });
            } else {
                // TODO::: Afficher un message informant l'utilisateur de choisir un fichier
                $('.err-msg').fadeIn(500)
                this.import_loading = false
            }
		},

		successMsg: function(message) {
            this.$toasted.show(message, {
                duration: 3000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                theme: 'toasted-primary',
                type: 'success',
                position: 'top-center'

            })
        },

		initFormSouscripteur() {
			
			this.getChampTauxAssurance(this.$route.params.id)
		},

		async saveSouscripteur() {
            const isValid = await this.$refs.add_souscripteur.validate();
            if (!isValid) {
                return;
            }

			this.souscripteur.assurance_id = this.$route.params.id
			this.souscripteur.user_id = this.user_id

			
			this.save_loading = true
			this.societe_is_exist = false

			console.log(this.souscripteur);

			this.$store.dispatch('saveSouscripteur', this.souscripteur).then((response) => {
				if (response.success) {
					$('.add-souscripteur').modal('hide')

					this.champ_taux_assurance.forEach((el, i) => {
						this.souscripteur.c_model[i].valeur = ''
					});
					this.souscripteur.societe = ''
					this.souscripteur.date_effet = ''
					this.souscripteur.date_expire = ''
					this.souscripteur.is_edit = 0

					this.$refs.add_souscripteur.reset()
					this.refreshListeSouscripteur()

					this.successMsg('Souscripteur ajouté avec succès')
				} else {
					if (response.code == 409) {
						this.societe_is_exist = true
					}
				}
				this.save_loading = false
			}).catch(() => {
                this.save_loading = false
                this.is_error = true
				this.errorToast("Une erreur s'est produite !")
            })
		},

		editSouscripteur(data) {
			// this.getChampTauxAssurance(this.assurance_id)
			
			let nk_choisi = []
            this.souscripteur.c_model.forEach(chkd => {
                var is_found = data.prestation.some(el => {
                    return el.libelle == chkd.champ_taux
                })

                if (!is_found) {
                    let k = {
                        libelle: chkd.champ_taux,
                        taux: '',
						taux_id: 0
                    }
                    nk_choisi.push(k)
                }
            });

			console.log("B: ",this.souscripteur);

			data.prestation.push(...nk_choisi)
			this.souscripteur.c_model = []

			data.prestation.forEach(el => {
				let taux = (el.taux != '')?parseInt(el.taux * 100):''
				this.souscripteur.c_model.push({ valeur: taux, champ_id: el.taux_id, champ_taux: el.libelle })
			});
			

			this.souscripteur = {
				user_id: this.user_id,
				is_edit: data.souscripteur_id,
				assurance_id: this.assurance_id,
				societe: data.souscripteur,
				date_effet: data.date_effet,
				date_expire: data.date_expire_le,
				c_model: this.souscripteur.c_model
			}

			this.liste_champs_taux = this.champ_taux_assurance

			$('.add-souscripteur').modal('show')

			
		},

		/**
		 * Selectionner un souscripteur à supprimer
		 * @param {*} selector 
		 */
		removeSouscripteur(data) {
			this.to_be_deleted = {
                souscripteur_id: data.souscripteur_id,
                societe: data.souscripteur,
				assurance_id: this.assurance_id
            }
		},

		supprimerSouscripteur() {
			this.del_loading = true;

            let confirm = document.getElementById('cfrm-del-societe');
            let err = 0

            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                err++;
                this.del_loading = false;
            }

            if (err == 0) {
                this.$store.dispatch('deleteSouscripteur', this.to_be_deleted).then((response) => {
                    
                    if (response > 0) {
                        this.successMsg('Souscripteur supprimé avec succès')
                    }

					$('.modal').modal('hide')
                    this.del_loading = false
                    this.is_confirm = false
                })
            }
		},

		async formatComma(selector) {
            $('#' + selector).val($('#' + selector).val().replace(/[^0-9,.]+/g, ''))
        },

		viewTaux(data) {
			console.log(">> T l ",data);
			this.liste_taux_prestation = data

			$('.view-taux').modal('show')
		},

		/**
		 * Modifier un taux (Nom prestation + plafond de prise en charge de l'assurance)
		 */
		// editTaux(data) {
		// 	this.is_edit = data.champ_id
		// 	this.taux_couverture[0] = {
		// 		prestation: { 'slug': data.champ_taux, 'libelle': data.champ_taux },
		// 		// plafond: data.plafond
		// 	}

		// 	this.is_liste_taux = false
		// },

		/**
		 * Supprimer un taux
		 */
		removeTaux(data) {
			this.to_be_deleted = {
                champ_id: data.champ_id,
                champ_taux: data.champ_taux,
				assurance_id: this.$route.params.id
            }
		},

		/**
         * Cache le message d'erreur au click du checkbox
         */
		onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

		/**
		 * Retirer un taux de couverture
		 */
		supprimerTaux() {
            this.del_loading = true;

            let confirm = document.getElementById('cfrm-del-taux');
            let err = 0

            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                err++;
                this.del_loading = false;
            }

            if (err == 0) {
                this.$store.dispatch('deleteTauxCouverture', this.to_be_deleted).then((response) => {
                    
                    if (response > 0) {
                        this.successMsg('Taux de couverture supprimé avec succès')
                    }

					this.getChampTauxAssurance(this.$route.params.id)
					this.refreshListeSouscripteur()
					$('.modal').modal('hide')
                    this.del_loading = false;
                    this.is_confirm = false
                })
            }
        },

		toggleListeTaux() {
			this.is_liste_taux = (this.is_liste_taux)?false:true
		},

		// addMore() {
		// 	this.taux_couverture.push({
		// 		prestation: '',
		// 	})
		// },

		// removeMore(index) {
		// 	this.taux_couverture.splice(index, 1)
		// },

		async addTaux() {
			this.save_loading = true;
            this.choice_empty = false

            const isValid = await this.$refs.add_taux_form.validate();
            if (!isValid) {
                this.save_loading = false
                this.btn_disable = false
                return;
            }

			const data = {
				taux_couverture: this.taux_couverture,
				assurance_id: this.$route.params.id,
				is_edit: this.is_edit
			}

			console.log(data);
			this.$store.dispatch('saveTauxCouverture', data).then((response) => {
				if (response.success) {
					this.getChampTauxAssurance(this.$route.params.id)
					
					this.taux_couverture = []
					this.$refs.add_taux_form.reset()

					this.toggleListeTaux()
				} else {
					if (response.code == 401) {
						this.choice_empty = true
					} else if (response.code == 500) {
						this.is_error = true
					}
				}

				this.save_loading = false
			}).catch(() => {
				this.is_error = true
				this.save_loading = false
			})
		}
	}
}


